import useWorkspaceContext from "@/hooks/useWorkspaceContext"
import LogoSvg from "@/svg/logo"
import { Image, ImageProps, Text, VStack } from "@chakra-ui/react"
import Link from "next/link"

const Logo = (props: ImageProps & { link?: string }) => {
  const { current } = useWorkspaceContext()
  const isBranded = Boolean(current) && current?.subdomain !== "app"

  const mark = current?.logo?.url ? (
    <Image
      src={current.logo.url}
      alt={current.name}
      {...props}
      width="auto"
      height="40px"
      maxWidth="100px"
      objectFit="contain"
      objectPosition="center"
    />
  ) : isBranded ? (
    <Text
      fontFamily="GTMaru"
      fontWeight="bold"
      noOfLines={1}
      title={current!.name}
      maxWidth={{ base: "160px", md: "280px" }}
    >
      {current!.name}
    </Text>
  ) : (
    <LogoSvg {...props} />
  )

  const brandMark = isBranded ? (
    <VStack spacing={0} align="center">
      {mark}
      <Text fontSize="9px" color="currentColor" opacity={0.6} lineHeight="1">
        by Amalibri
      </Text>
    </VStack>
  ) : (
    mark
  )

  if (!Link) {
    return brandMark
  }

  return <Link href="/">{brandMark}</Link>
}

export default Logo
